<template>
	<main-page :user="user" color="blue">
		<template v-slot:title> </template>

		<div class="container-fluid" style="text-align: left;">
			<div class="row mt-3">
				<div class="col-sm-3">
					<admin-nav></admin-nav>
				</div>

				<div class="col-sm-9">
					<h4>User Edit</h4>
					<br />

					<div class="col-6">
						<div v-if="editUser && editUser.name" class="form-group">
							<label for="exampleInputEmail1">First Name</label>
							<input type="text" v-model="editUser.name.first" class="form-control" />
						</div>
						<div v-if="editUser && editUser.name" class="form-group">
							<label for="exampleInputEmail1">Last Name</label>
							<input type="text" v-model="editUser.name.last" class="form-control" />
						</div>
						<div class="form-group">
							<label for="exampleInputEmail1">Email address</label>
							<input type="text" v-model="editUser.email" class="form-control" />
						</div>
						<div class="form-group">
							<label for="exampleInputEmail1">Role</label>
							<v-select :options="roles" v-model="editUser.role" :clearable="false"></v-select>
						</div>
						<div class="form-group">
							<label for="exampleInputEmail1">District</label>
							<v-select
								label="name"
								:options="districts"
								v-model="editUser.district_id"
								:clearable="false"
								:reduce="(d) => d.id"
							></v-select>
						</div>
						<div class="form-group">
							<label class="md-check check-sm">
								<input
									v-model="editUser.disabled"
									type="checkbox"
								/>
								<i class="cyan"></i> Disable User
							</label>
							<small id="detailHelp" class="form-text text-muted"
								>Users that are disabled are not able to login.</small
							>
						</div>

						<template v-if="editUser.id && !editUser.disabled">
							<hr />

							<button @click="openSetPasswordModal" class="btn btn-success">
								Set Password...
							</button>
						</template>

						<a href="/#/users" class="btn float-right">Cancel</a>
						<button @click="save" class="btn btn-primary float-right">
							Save
						</button>
					</div>
				</div>
			</div>
		</div>

		<b-modal id="setPasswordModal" headerClass="indigo">
			<template v-slot:modal-title>
				<h3 class="modal-title full-bar-title">Set Password</h3>
			</template>
			<div class="p-2">
				<div class="form-group pl-2 pr-3">
					<label>Password</label>
					<input type="password" v-model="password1" class="form-control" />
				</div>
				<div class="form-group pl-2 pr-3">
					<label>Confirm Password</label>
					<input type="password" v-model="password2" class="form-control" />
				</div>
				<div class="ml-2" style="min-height: 23px;">
					<div v-for="(error, i) in passwordErrors" :key="i" class="text-danger">
						<i class="fas fa-exclamation-triangle mr-1" />{{ error }}
					</div>
				</div>
			</div>
			<template v-slot:modal-footer="{ ok, cancel }">
				<button type="button" class="btn btn-secondary" @click="cancel">Cancel</button>
				<button v-if="!canSetPassword" type="button" class="btn btn-secondary" disabled>
					Set Password
				</button>
				<button v-if="canSetPassword" type="button" class="btn btn-primary" @click="setPassword(ok)">
					Set Password
				</button>
			</template>
		</b-modal>
	</main-page>
</template>

<script>
import MainPage from "@/components/MainPage";
import AdminNav from "@/vues/admin/AdminNav";
import AdminService from "@/services/AdminService";
import Notie from "@/services/NotieService";

export default {
	name: "UserEdit",

	props: ["user"],

	components: { MainPage, AdminNav },

	data() {
		return {
			service: AdminService,
			editUser: { district_id: null },
			roles: ["ADMIN", "TEACHER", "STUDENT", "PARTNER", "JUDGE"],
			districts: [],

			password1: null,
			password2: null,
			passwordErrors: [],
			canSetPassword: false,
		};
	},

	created() {
		AdminService.listDistricts({})
			.then((resp) => {
				this.districts = resp.data.result;
			})
			.catch((e) => {
				console.log(e);
				Notie.error("Failed to load districts", e);
			});

		var id = this.$route.params.id;
		if (id == "new") {
			this.editUser = {
				name: {},
				role: "STUDENT",
				district_id: null,
			};
			return;
		}
		this.service
			.getUser(id)
			.then((resp) => {
				this.editUser = resp.data;
			})
			.catch((err) => {
				alert(err);
			});
	},

	watch: {
		password1() {
			this.checkValidPassword();
		},

		password2() {
			this.checkValidPassword();
		},
	},

	methods: {
		save() {
			this.service
				.saveUser(this.editUser)
				.then((r) => {
					this.$router.replace(`/users/${r.data.id}`);
					Notie.success("Saved user");
				})
				.catch((err) => {
					alert(err);
				});
		},

		districtSearch(search, loading) {
			console.log(search, loading);
			AdminService.listDistricts({ filter: search }).then((resp) => {
				this.programs = resp.data.result;
			});
		},

		openSetPasswordModal() {
			this.password1 = null;
			this.password2 = null;
			this.passwordErrors = [];
			this.$bvModal.show("setPasswordModal");
		},

		checkValidPassword() {
			this.passwordErrors = this.getPasswordErrors();
			this.canSetPassword = this.passwordErrors.length == 0 && this.password1 && this.password2;
		},

    checkPasswordLen(pass) {
      if (!pass) {
        return true;
      }
      return pass.length >= 8 && pass.length <= 16;
    },

    checkPasswordChars(pass) {
      if (!pass) {
        return true;
      }
      return (
        pass.match(/.*[A-Z].*/) &&
        pass.match(/.*[a-z].*/) &&
        pass.match(/.*[0-9].*/)
      );
    },

    checkPassword(pass) {
      return this.checkPasswordLen(pass) && this.checkPasswordChars(pass);
    },

    checkMatch(pass1, pass2) {
      if (pass1 && pass2) {
        if (pass1 != pass2) {
          return false;
        }
      }
      return true;
    },

    getPasswordErrors() {
      var errs = [];
      if (!this.checkPasswordChars(this.password1)) {
        errs.push(
          "Must include at least one lowercase (a-z), at least one uppercase (A-Z), and at least one digit (0-9)"
        );
      }
      if (!this.checkPasswordLen(this.password1)) {
        errs.push("Password must be between 8 and 16 characters");
      }
      if (!this.checkMatch(this.password1, this.password2)) {
        errs.push("Passwords must match");
      }
      return errs;
    },
		setPassword(callback) {
			AdminService.setUserPassword(this.editUser.id, this.password1)
				.then(() => {
					Notie.success("Password set");
					callback();
				})
				.catch((e) => {
					console.log(e);
					Notie.error("Failed to set password", e);
				});
		},
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
